export type CimmplePayHelpDocItem = {
  sourcePath: string;
  routePath: string;
  title: string;
};

export const cimmplePayHelpDocsManifest: CimmplePayHelpDocItem[] = [
  {
    "sourcePath": "company/company-setup.md",
    "routePath": "company/company-setup",
    "title": "Company profile and payroll setup"
  },
  {
    "sourcePath": "employees/employee-setup.md",
    "routePath": "employees/employee-setup",
    "title": "Employees, pay, and deductions"
  },
  {
    "sourcePath": "glossary.md",
    "routePath": "glossary",
    "title": "Glossary"
  },
  {
    "sourcePath": "pay-runs/pay-schedules.md",
    "routePath": "pay-runs/pay-schedules",
    "title": "Pay schedules"
  },
  {
    "sourcePath": "pay-runs/run-payroll-overview.md",
    "routePath": "pay-runs/run-payroll-overview",
    "title": "Running payroll"
  },
  {
    "sourcePath": "payments/ach-nacha-file.md",
    "routePath": "payments/ach-nacha-file",
    "title": "ACH / NACHA file and your bank"
  },
  {
    "sourcePath": "payments/printed-checks.md",
    "routePath": "payments/printed-checks",
    "title": "Printed checks"
  },
  {
    "sourcePath": "README.md",
    "routePath": "",
    "title": "CimmplePay Help & Knowledge Base"
  },
  {
    "sourcePath": "reports/reports-and-exports.md",
    "routePath": "reports/reports-and-exports",
    "title": "Reports and exports"
  },
  {
    "sourcePath": "security/data-and-access.md",
    "routePath": "security/data-and-access",
    "title": "Data, access, and responsibilities"
  },
  {
    "sourcePath": "start-here/what-cimmplepay-does.md",
    "routePath": "start-here/what-cimmplepay-does",
    "title": "What CimmplePay does (and what you still must do)"
  },
  {
    "sourcePath": "start-here/who-its-for.md",
    "routePath": "start-here/who-its-for",
    "title": "Who this product is for"
  },
  {
    "sourcePath": "taxes/deposits-and-filings-your-responsibility.md",
    "routePath": "taxes/deposits-and-filings-your-responsibility",
    "title": "Deposits and filings: your responsibility"
  },
  {
    "sourcePath": "taxes/federal-taxes.md",
    "routePath": "taxes/federal-taxes",
    "title": "Federal taxes (withholding and employer)"
  },
  {
    "sourcePath": "taxes/state-and-local-taxes.md",
    "routePath": "taxes/state-and-local-taxes",
    "title": "State and local taxes"
  },
  {
    "sourcePath": "taxes/taxes-overview.md",
    "routePath": "taxes/taxes-overview",
    "title": "Taxes overview"
  },
  {
    "sourcePath": "troubleshooting/common-issues.md",
    "routePath": "troubleshooting/common-issues",
    "title": "Common issues"
  },
  {
    "sourcePath": "year-end/year-end-overview.md",
    "routePath": "year-end/year-end-overview",
    "title": "Year-end overview"
  }
];

export const cimmplePayHelpDocsByRoute = new Map(
  cimmplePayHelpDocsManifest.map((item) => [item.routePath, item])
);

export const cimmplePayHelpSidebarGroups: Array<{ label: string; items: CimmplePayHelpDocItem[] }> = [
  {
    "label": "Start here",
    "items": [
      {
        "sourcePath": "start-here/what-cimmplepay-does.md",
        "routePath": "start-here/what-cimmplepay-does",
        "title": "What CimmplePay does (and what you still must do)"
      },
      {
        "sourcePath": "start-here/who-its-for.md",
        "routePath": "start-here/who-its-for",
        "title": "Who this product is for"
      }
    ]
  },
  {
    "label": "Company & setup",
    "items": [
      {
        "sourcePath": "company/company-setup.md",
        "routePath": "company/company-setup",
        "title": "Company profile and payroll setup"
      }
    ]
  },
  {
    "label": "Employees",
    "items": [
      {
        "sourcePath": "employees/employee-setup.md",
        "routePath": "employees/employee-setup",
        "title": "Employees, pay, and deductions"
      }
    ]
  },
  {
    "label": "Pay schedules & pay runs",
    "items": [
      {
        "sourcePath": "pay-runs/pay-schedules.md",
        "routePath": "pay-runs/pay-schedules",
        "title": "Pay schedules"
      },
      {
        "sourcePath": "pay-runs/run-payroll-overview.md",
        "routePath": "pay-runs/run-payroll-overview",
        "title": "Running payroll"
      }
    ]
  },
  {
    "label": "Taxes",
    "items": [
      {
        "sourcePath": "taxes/taxes-overview.md",
        "routePath": "taxes/taxes-overview",
        "title": "Taxes overview"
      },
      {
        "sourcePath": "taxes/federal-taxes.md",
        "routePath": "taxes/federal-taxes",
        "title": "Federal taxes (withholding and employer)"
      },
      {
        "sourcePath": "taxes/state-and-local-taxes.md",
        "routePath": "taxes/state-and-local-taxes",
        "title": "State and local taxes"
      },
      {
        "sourcePath": "taxes/deposits-and-filings-your-responsibility.md",
        "routePath": "taxes/deposits-and-filings-your-responsibility",
        "title": "Deposits and filings: your responsibility"
      }
    ]
  },
  {
    "label": "Paying employees",
    "items": [
      {
        "sourcePath": "payments/printed-checks.md",
        "routePath": "payments/printed-checks",
        "title": "Printed checks"
      },
      {
        "sourcePath": "payments/ach-nacha-file.md",
        "routePath": "payments/ach-nacha-file",
        "title": "ACH / NACHA file and your bank"
      }
    ]
  },
  {
    "label": "Reports & bookkeeping",
    "items": [
      {
        "sourcePath": "reports/reports-and-exports.md",
        "routePath": "reports/reports-and-exports",
        "title": "Reports and exports"
      }
    ]
  },
  {
    "label": "Year-end",
    "items": [
      {
        "sourcePath": "year-end/year-end-overview.md",
        "routePath": "year-end/year-end-overview",
        "title": "Year-end overview"
      }
    ]
  },
  {
    "label": "Troubleshooting",
    "items": [
      {
        "sourcePath": "troubleshooting/common-issues.md",
        "routePath": "troubleshooting/common-issues",
        "title": "Common issues"
      }
    ]
  },
  {
    "label": "Security & data",
    "items": [
      {
        "sourcePath": "security/data-and-access.md",
        "routePath": "security/data-and-access",
        "title": "Data, access, and responsibilities"
      }
    ]
  },
  {
    "label": "Reference",
    "items": [
      {
        "sourcePath": "glossary.md",
        "routePath": "glossary",
        "title": "Glossary"
      }
    ]
  }
];
